export type TabsProps = {
  tabsData: Array<{
    name: string;
    description: string;
  }>;
  tabsDesctiptionClassName?: string;
  activeIndex?: number;
};

export const START_INDEX = 51;
